import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button } from 'antd';

const CreateMerchantModal = ({ visible, onClose, onCreate, accountId }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible && accountId) {
            form.setFieldsValue({ account_id: accountId });
        }
    }, [visible, accountId, form]);

    const handleFinish = async (values) => {
        setLoading(true);
        try {
            await onCreate(values); // values will include account_id
            form.resetFields();
            onClose();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Create New Merchant"
            visible={visible}
            onCancel={() => {
                form.resetFields();
                onClose();
            }}
            footer={null}
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item
                    name="merchant_name"
                    label="Merchant Name"
                    rules={[{ required: true, message: 'Please enter merchant name' }]}
                >
                    <Input placeholder="Enter merchant name" />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} style={{ marginRight: 8 }}>
                        Create
                    </Button>
                    <Button onClick={() => {
                        form.resetFields();
                        onClose();
                    }}>
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CreateMerchantModal;
